import styled from 'styled-components';

export default styled.img`
  top: 0;
  width: 100%;
`;
